import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function HowItWorksLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'navigation-how-it-works-link'}
            title={intl.formatMessage({id: 'navigation.link.howItWorks.title'})}
            to={Routes.SEE_HOW_IT_WORKS}
        >
            <span>
                <FormattedMessage id={'navigation.link.howItWorks.text'} />
            </span>
        </NavLink>
    );
}
